/* eslint-disable max-len */
import * as React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { SearchReset } from '@uncinc/react-searchkit';

import { Container, useDialog } from '@uncinc/uncinc-react-kitchen-sink';

import Button from '../../Button';
import { ButtonProps } from '../../Button/types';

import './style.scss';

const ResetButton: React.FC = (props) => {
  const { t } = useTranslation();

  return (
    <button
      {...props}
      type="button"
      className="a SearchFilterDialog__reset-button"
    >
      {t('searchkit.buttons.reset_alt')}
    </button>
  );
};

interface DialogProps {
  dialogIsOpen: boolean;
  openDialog: () => void;
  closeDialog: () => void;
}

interface Props {
  title: string;
  children: ((dialogProps: DialogProps) => React.ReactNode) | React.ReactNode;
  openButtonProps?: ButtonProps;
}

const SearchFilterDialog: React.FC<Props> = React.memo((props) => {
  const {
    title,
    children,
    openButtonProps,
  } = props;
  const { t } = useTranslation();

  const {
    openDialog,
    closeDialog,
    dialogIsOpen,
  } = useDialog();

  const dialogClassNames = c('Dialog', 'SearchFilterDialog__dialog', {
    isOpen: dialogIsOpen,
  });

  return (
    <div className="SearchFilterDialog">
      <Button
        {...openButtonProps}
        className="SearchFilterDialog__open"
        type="secondary"
        icon="filter_list"
        onClick={() => openDialog()}
      >
        {t('buttons.filter')}
      </Button>

      <div className={dialogClassNames}>
        <div className="Dialog__wrapper">
          <div className="Dialog__content">
            <Container className="Dialog__content root-container">
              <div className="row">
                <div className="col-12">
                  <header className="SearchFilterDialog__header">
                    <h2 className="asH3">{title}</h2>
                    <SearchReset
                      button={ResetButton}
                      onClick={closeDialog}
                    />
                    <Button
                      className="SearchFilterDialog__close"
                      type="secondary"
                      icon="clear"
                      iconPosition="left"
                      onClick={() => closeDialog()}
                    >
                      {t('buttons.close')}
                    </Button>
                  </header>

                  {typeof children === 'function' ? (
                    children({ dialogIsOpen, openDialog, closeDialog })
                  ) : (
                    children
                  )}
                </div>
              </div>
            </Container>
          </div>
        </div>

        <div
          className="Dialog__backdrop"
          aria-label={t('buttons.close')}
        />
      </div>
    </div>
  );
});

export default SearchFilterDialog;
